import { FirebaseError } from 'firebase/app';

const MENSAJES: Record<string, string> = {
  'auth/invalid-email': 'El correo no tiene un formato válido.',
  'auth/user-disabled': 'Esta cuenta está deshabilitada.',
  'auth/user-not-found': 'Correo o contraseña incorrectos.',
  'auth/wrong-password': 'Correo o contraseña incorrectos.',
  'auth/invalid-credential': 'Correo o contraseña incorrectos.',
  'auth/too-many-requests': 'Demasiados intentos. Espera unos minutos.',
  'auth/network-request-failed': 'Sin conexión. Revisa tu internet.',
  'auth/configuration-not-found': 'Falta habilitar el proveedor de correo en Firebase.',
  'auth/weak-password': 'La contraseña debe tener al menos 6 caracteres.',
  'auth/requires-recent-login':
    'Por seguridad, cierra sesión y vuelve a entrar antes de cambiar tu contraseña.',
};

/** Traduce un error de Firebase Auth a un mensaje para mostrar al usuario. */
export function mensajeErrorAuth(
  err: unknown,
  fallback = 'No se pudo completar la acción. Intenta de nuevo.',
): string {
  if (err instanceof FirebaseError) {
    return MENSAJES[err.code] ?? fallback;
  }
  return fallback;
}
